<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs
        headline="Tổng quan"
        :link="[
          { text: 'Cơ sở vật chất', href: '/facility' },
          { text: 'Dashboard & Thống kê', href: '/facility' }
        ]"
      />
      <v-btn color="primary" outlined @click="loadStatistics">
        <v-icon left>mdi-refresh</v-icon> Làm mới số liệu
      </v-btn>
    </div>

    <!-- 4 THẺ THỐNG KÊ TỔNG QUAN -->
    <v-row class="mx-2 mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="pa-4 text-center">
          <div class="text-caption grey--text text-uppercase font-weight-bold">Tổng số thiết bị</div>
          <div class="text-h4 font-weight-bold primary--text my-2">{{ stats.totalQuantity || 0 }}</div>
          <div class="text-caption grey--text">
            {{ stats.totalItems || 0 }} chủng loại | {{ (stats.totalEstimatedValue || 0).toLocaleString('vi-VN') }} đ
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="pa-4 text-center">
          <div class="text-caption grey--text text-uppercase font-weight-bold">Đang khả dụng</div>
          <div class="text-h4 font-weight-bold success--text my-2">{{ stats.totalAvailable || 0 }}</div>
          <div class="text-caption success--text">Sẵn sàng phục vụ giảng dạy</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="pa-4 text-center">
          <div class="text-caption grey--text text-uppercase font-weight-bold">Đang cho mượn</div>
          <div class="text-h4 font-weight-bold indigo--text my-2">{{ stats.totalBorrowed || 0 }}</div>
          <div class="text-caption indigo--text">Đang sử dụng ngoài lớp</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="pa-4 text-center">
          <div class="text-caption grey--text text-uppercase font-weight-bold">Hỏng & Bảo trì</div>
          <div class="text-h4 font-weight-bold error--text my-2">
            {{ (stats.totalMaintenance || 0) + (stats.totalBroken || 0) }}
          </div>
          <div class="text-caption error--text">
            {{ stats.totalBroken || 0 }} hỏng - {{ stats.totalMaintenance || 0 }} bảo trì
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- BẢNG PHÂN BỔ THIẾT BỊ THEO DANH MỤC & LỐI TẮT -->
    <v-row class="mx-2">
      <v-col cols="12" md="8">
        <v-card outlined class="pa-4">
          <div class="text-subtitle-1 font-weight-bold mb-3 primary--text">
            <v-icon left color="primary">mdi-format-list-bulleted-type</v-icon>
            Phân bổ thiết bị theo đầu mục
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr class="grey lighten-4">
                  <th>Đầu mục</th>
                  <th class="text-center">Tổng số lượng</th>
                  <th class="text-center">Số lượng khả dụng</th>
                  <th class="text-center">Tỷ lệ sẵn sàng</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!stats.categoryStats || stats.categoryStats.length === 0">
                  <td colspan="4" class="text-center grey--text py-3">Chưa có dữ liệu đầu mục</td>
                </tr>
                <tr v-for="(cat, idx) in stats.categoryStats || []" :key="idx">
                  <td><strong>{{ cat.name }}</strong></td>
                  <td class="text-center font-weight-bold">{{ cat.quantity }}</td>
                  <td class="text-center success--text font-weight-bold">{{ cat.available }}</td>
                  <td class="text-center">
                    <v-progress-linear
                      :value="cat.quantity > 0 ? (cat.available / cat.quantity) * 100 : 0"
                      color="teal"
                      height="15"
                      rounded
                    >
                      <template v-slot:default="{ value }">
                        <strong style="font-size: 10px; color: white">{{ Math.ceil(value) }}%</strong>
                      </template>
                    </v-progress-linear>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- PHÍM TẮT THAO TÁC NHANH -->
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 fill-height">
          <div class="text-subtitle-1 font-weight-bold mb-3 primary--text">
            <v-icon left color="primary">mdi-lightning-bolt</v-icon>
            Truy cập nhanh các phân hệ
          </div>
          <v-list dense class="pa-0">
            <v-list-item link to="/facility/assets" class="px-2 mb-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="primary">mdi-devices</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Danh sách thiết bị & In tem QR</v-list-item-title>
                <v-list-item-subtitle>Quản lý tài sản, in mã vạch</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/facility/borrows" class="px-2 mb-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="indigo">mdi-handshake</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Mượn - Trả trực tuyến</v-list-item-title>
                <v-list-item-subtitle>Duyệt mượn, bàn giao, trả máy</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/facility/transfers" class="px-2 mb-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="warning">mdi-swap-horizontal-bold</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Xuất - Nhập - Luân chuyển</v-list-item-title>
                <v-list-item-subtitle>Chứng từ nhập kho, điều chuyển phòng</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/facility/maintenance" class="px-2 mb-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="error">mdi-wrench</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Báo hỏng & Bảo trì</v-list-item-title>
                <v-list-item-subtitle>Sửa chữa, đặt lịch bảo dưỡng</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/facility/inventory" class="px-2 mb-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="teal">mdi-clipboard-check</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Kiểm kê tài sản</v-list-item-title>
                <v-list-item-subtitle>Đối soát sổ sách & thực tế</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/facility/proposals" class="px-2 rounded border">
              <v-list-item-icon class="mr-3"><v-icon color="deep-purple">mdi-file-document-edit</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Đề xuất mua sắm</v-list-item-title>
                <v-list-item-subtitle>Dự toán kinh phí & phê duyệt</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { Asset } from '@/plugins/api'

export default {
  name: 'FacilityDashboard',
  components: { Breadcrumbs },
  data() {
    return {
      stats: {}
    }
  },
  async created() {
    await this.loadStatistics()
  },
  methods: {
    async loadStatistics() {
      try {
        const res = await Asset.getStatistics()
        this.stats = res || {}
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px solid #e0e0e0;
}
</style>
